export function lockedStatementIdsFromSummary(summary) {
  if (!summary || summary.blockReason === 'CLOSED_PERIOD') return []
  const participants = Array.isArray(summary.participants) ? summary.participants : []
  const fromParticipants = participants
    .filter((item) => item?.isLocked !== false)
    .map((item) => String(item?.statementId || '').trim())
    .filter(Boolean)
  if (fromParticipants.length) return Array.from(new Set(fromParticipants))
  const fallback = String(summary.statementId || '').trim()
  return fallback ? [fallback] : []
}
